import { getRgVersions } from "./index194.js";
import { aggPropsToDto } from "@project-rouge/rg-core";
function aggPropsToDto$1(raw) {
	return aggPropsToDto({
		raw,
		versions: getRgVersions()
	});
}
export { aggPropsToDto$1 as aggPropsToDto };

//# sourceMappingURL=index201.js.map